"use strict"

import angular from "angular"
import routes from "./admin.routes"
import AdminController from "./admin.controller"
import "angular-xeditable"

export default angular
  .module("makeamapAngularApp.admin", ["makeamapAngularApp.auth", "ui.router", "xeditable"])
  .config(routes)
  .controller("AdminController", AdminController).name
